import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarMobileContext = createContext(null);

export function SidebarMobileProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const value = {
    isOpen,
    setIsOpen,
    openSidebar: () => setIsOpen(true),
    closeSidebar: () => setIsOpen(false),
  };

  return (
    <SidebarMobileContext.Provider value={value}>
      {children}
    </SidebarMobileContext.Provider>
  );
}

export function useSidebarMobile() {
  const ctx = useContext(SidebarMobileContext);
  if (!ctx) {
    throw new Error('useSidebarMobile must be used within SidebarMobileProvider');
  }
  return ctx;
}

/** Safe for components that may render outside the provider (e.g. legacy layouts). */
export function useSidebarMobileOptional() {
  return useContext(SidebarMobileContext);
}
